import { getJSTCurrentTime } from "@/util/datetime";
import { DatePicker } from "../atoms/datePicker";

const Days = ["日", "月", "火", "水", "木", "金", "土"] as const;
const getLabel = (date: Date) => {
  return `${date.getMonth() + 1}月${date.getDate()}日(${Days[date.getDay()]})`;
};

export type ToolbarProps = {
  onChangeDate: (date: string) => void;
  targetDateSelected?: string;
};

export const CalendarToolbar = ({
  onChangeDate,
  targetDateSelected,
}: ToolbarProps) => {
  const selectedDate = targetDateSelected ?? getJSTCurrentTime("date");

  const moveDate = (dayOffset: number) => {
    const baseDate = new Date(`${selectedDate}T00:00:00.000Z`);
    baseDate.setUTCDate(baseDate.getUTCDate() + dayOffset);
    onChangeDate(baseDate.toISOString().slice(0, 10));
  };

  const resetToday = () => {
    onChangeDate(
      new Date(getJSTCurrentTime("date")).toISOString().slice(0, 10)
    );
  };

  return (
    <div className="bigCalendarToolbar" style={{ cursor: "default" }}>
      <button
        type="button"
        className="calendar-date-move-btn calendar-date-move-btn-prev"
        aria-label="前の日"
        onClick={() => moveDate(-1)}
      >
        {"<"}
      </button>
      <button
        type="button"
        className="reset-today-btn"
        aria-label="今日に移動"
        onClick={resetToday}
      >
        今日
      </button>
      <DatePicker
        value={selectedDate}
        onChange={(date) => date && onChangeDate(date)}
        sx={{
          border: "1px solid #ccc",
          padding: "10px 20px 10px 20px",
          height: "47px",
          width: "65px",
          ":hover": {
            backgroundColor: "skyblue",
          },
        }}
        inputStyle={{
          padding: 0,
          fontSize: 20,
        }}
      />
      <button
        type="button"
        className="calendar-date-move-btn calendar-date-move-btn-next"
        aria-label="次の日"
        onClick={() => moveDate(1)}
      >
        {">"}
      </button>
      <div className="bigCalendarToolbarLabel">
        <label>{getLabel(new Date(`${selectedDate}T00:00:00.000Z`))}</label>
      </div>
    </div>
  );
};
